module.exports = __webpack_public_path__ + "img/banner.0d61e1e0.png";